import { useState } from "react";
import { ChevronDown, ChevronRight, FolderOpen } from "lucide-react";
import CustomerProfileDocumentsBlock from "../customer-blocks/CustomerProfileDocumentsBlock";

/**
 * Thin wrapper around CustomerProfileDocumentsBlock so the full 8-folder
 * hub can be collapsed into a one-line header — matches the fold/unfold
 * consistency of every other portal section.
 */
export default function PortalDocumentsFoldable({ customerId, apiBase, canEdit = false, canDelete = false, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="hv-card p-4" data-testid="portal-documents-foldable">
      <header
        className="flex items-center justify-between cursor-pointer gap-2"
        onClick={() => setOpen((v) => !v)}
        data-testid="portal-documents-foldable-toggle"
      >
        <div className="flex items-center gap-2 min-w-0">
          {open ? <ChevronDown className="w-4 h-4 text-[#647087]" /> : <ChevronRight className="w-4 h-4 text-[#647087]" />}
          <div className="w-7 h-7 rounded-md flex items-center justify-center bg-[#A78BFA]/15 border border-[#A78BFA]/40 text-[#A78BFA] shrink-0">
            <FolderOpen className="w-4 h-4" />
          </div>
          <h3 className="font-display text-base font-bold truncate">Documents</h3>
          <span className="text-[10px] font-mono px-2 py-0.5 rounded-full border border-[#A78BFA]/30 text-[#A78BFA] bg-[#A78BFA]/5">
            8 folders
          </span>
        </div>
      </header>
      {open && (
        <div className="mt-3" data-testid="portal-documents-foldable-panel">
          <CustomerProfileDocumentsBlock
            customerId={customerId}
            apiBase={apiBase}
            canEdit={canEdit}
            canDelete={canDelete}
            hideHeader
          />
        </div>
      )}
    </section>
  );
}
